import { useContext, useEffect, useRef } from 'react';
import UIContext from '../contexts/ui/UIContext';

export default function useControlBrowserNavigation(onPreventingBack, useBeforeUnload = true) {

  const paused = useRef(false);
  const {isMajorUpdateModalVisible} = useContext(UIContext);
  const isMajorUpdateModalVisibleRef = useRef(isMajorUpdateModalVisible);

useEffect(() => {
  isMajorUpdateModalVisibleRef.current = isMajorUpdateModalVisible;
}, [isMajorUpdateModalVisible]);

  // From popstate event docs:
  // " [...] browsers may not fire the popstate event at all unless the page has been interacted with."
  // https://developer.mozilla.org/en-US/docs/Web/API/Window/popstate_event
  const onPopstate = (event) => {
    if (isMajorUpdateModalVisibleRef.current) return;
    if (!paused.current) { 
      event.preventDefault();
      setTimeout(() => {
        window.history.pushState(null, null, window.location.href);
      }, 0);
      onPreventingBack();
    }
  };

  // Preventing default for 'beforeunload' event is not supported in Safari
  // https://developer.mozilla.org/en-US/docs/Web/API/Window/beforeunload_event
  const onBeforeUnload = (event) => {
    if (isMajorUpdateModalVisibleRef.current) return;
    if (!paused.current) { 
      event.preventDefault();
      return "";
    }
  };

  const blockNav = () => {
    paused.current = true;
  };

  const unblockNav = () => {
    paused.current = false;
  };

  useEffect(() => {
    if (!paused.current) {
      window.history.pushState(null, null, window.location.href);

      if (useBeforeUnload) {
        window.addEventListener('beforeunload', onBeforeUnload);
      }

      window.addEventListener('popstate', onPopstate);

      return () => {
        window.removeEventListener('popstate', onPopstate);
        if (useBeforeUnload) {
          window.removeEventListener('beforeunload', onBeforeUnload);
        }
      };
    }
  }, []);

  return {
    blockState: paused.current ? 'paused' : 'blocking',
    blockNav,
    unblockNav
  };
}
